import React, { useState, useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import "./leaflet-idw-directdraw"; // Make sure this is imported correctly
import * as turf from '@turf/turf';


export default function Idw() {
  const {
    vis,
    layerControls,
    map,
    Canvas,
  } = useContext(GlobalContext);

  const [show, setshow] = useState(false);
  const [vectors, setVectors] = useState([]);
  const toolRef = useRef(null);
  const [selLayer1, setSelLayer1] = useState(null);
  const [idwLayer, setIdwLayer] = useState(null);
  const [expValue, setExpValue] = useState(6); 
  const [props, setProps] = useState([]);
    const [selProp, setSelProp] = useState(null);

  useEffect(() => {
    if (layerControls) {
      console.log("Layers in Canvas:", Canvas.getLayers());
      setVectors(Canvas.getLayers());
    }
    setSelLayer1(null);
   

    // Cleanup function to remove IDW layer when component unmounts
    return () => {
      if (idwLayer && map) {
        map.removeLayer(idwLayer);
      }
    };
  }, [show]);

   useEffect(() => {
      if (selLayer1) {
        setProps(Canvas.getProps(selLayer1, false));
      }
    }, [selLayer1]);

  // Function to extract point coordinates and values from GeoJSON
  const extractPointsWithValues = (geoJson) => {
    const points = [];
    geoJson.features.forEach(feature => {
      if (feature.geometry.type === "Point") {
        // Check for different possible value properties
        const value = feature.properties.rainfall_mm ||
          feature.properties.value ||
          feature.properties.z ||
          1; // Default value if none found

        // Note: Leaflet uses [lat, lng] format
        points.push([
          feature.geometry.coordinates[1], // lat
          feature.geometry.coordinates[0], // lng
          value
        ]);
      }
    });
    return points;
  };

  // const performIdw = () => {
  //     if (!selLayer1 || !selLayer2) {
  //         console.error("Please select both layers");
  //         return;
  //     }

  //     const layerData1 = Canvas.getLayerData(selLayer1); 
  //     const layerData2 = Canvas.getLayerData(selLayer2);
  //     console.log('layerData1', layerData1, 'layerData2', layerData2);

  //     if (!layerData1 || !layerData2) {
  //         console.error("Layer data is not valid.");
  //         return;
  //     }

  //     // Extract points with values from both layers
  //     const pointsLayer1 = extractPointsWithValues(layerData1);
  //     const pointsLayer2 = extractPointsWithValues(layerData2);
  //     console.log('pointsLayer1', pointsLayer1, 'pointsLayer2', pointsLayer2);

  //     // Combine points from both layers
  //     const allPoints = [...pointsLayer1, ...pointsLayer2];

  //     // Remove any existing IDW layer
  //     if (idwLayer && map) {
  //         map.removeLayer(idwLayer);
  //     }

  //     // Create new IDW layer
  //     const newIdwLayer = L.idwLayer(allPoints, {
  //         opacity: 0.7,
  //         cellSize: 15,
  //         exp: 6,
  //         max: 9,
  //         clipBounds: map.getBounds(),
  //         gradient: {
  //             0: '#ff66ff',
  //             0.1: '#990099',
  //             0.2: '#660066',
  //             0.3: 'Maroon',
  //             0.5: 'orange',
  //             0.6: 'yellow',
  //             0.7: 'lime',
  //             0.8: 'cyan',
  //             0.9: 'blue',
  //             1: '#000066'
  //         }
  //     });

  //     // Add to map
  //     newIdwLayer.addTo(map);
  //     setIdwLayer(newIdwLayer);

  //     // Add to layer controls if available
  //     if (layerControls) {
  //         layerControls.addOverlay(newIdwLayer, 'IDW Layer');
  //     }

  //     console.log('IDW Layer created and added to map');
  // };


  // const performIdw = () => {
  //     if (!selLayer1 || !selLayer2) {
  //       console.error("Please select both layers");
  //       return;
  //     }

  //     // Use Canvas utility to fetch layer GeoJSONs
  //     const layerData1 = Canvas.getLayerData(selLayer1); // Point layer (rainfall)
  //     const layerData2 = Canvas.getLayerData(selLayer2); // Polygon layer (AOI)

  //     console.log('layerData1', layerData1, 'layerData2', layerData2);

  //     if (!layerData1 || !layerData2 || !layerData2.features.length) {
  //       console.error("Invalid layer data");
  //       return;
  //     }

  //     // Extract rainfall points: [lat, lng, value]
  //     const rainfallPoints = layerData1.features
  //       .filter(f => f.geometry?.type === "Point")
  //       .map(f => [
  //         f.geometry.coordinates[1], // lat
  //         f.geometry.coordinates[0], // lng
  //         f.properties.rainfall_m ?? 1 // default to 1 if undefined
  //       ]);

  //       console.log('rainfallPoints', rainfallPoints);

  //     // Extract AOI vertices (MultiPolygon and Polygon support)
  //     const aoiVertices = [];
  //     const geometry = layerData2.features[0].geometry;
  //     console.log('geometry', geometry);

  //     if (geometry.type === "Polygon") {
  //       geometry.coordinates[0].forEach(coord => {
  //         aoiVertices.push([coord[1], coord[0], 0]);
  //       });
  //     } else if (geometry.type === "MultiPolygon") {
  //       geometry.coordinates.forEach(polygon => {
  //         polygon[0].forEach(coord => {
  //           aoiVertices.push([coord[1], coord[0], 0]);
  //         });
  //       });
  //     } else {
  //       console.error("Unsupported geometry type:", geometry.type);
  //       return;
  //     }

  //     const allPoints = [...rainfallPoints, ...aoiVertices];
  //     console.log('allPoints', allPoints);

  //     if (!allPoints.length) {
  //       console.error("No valid points to interpolate");
  //       return;
  //     }

  //     // Remove existing layer
  //     if (idwLayer && map) map.removeLayer(idwLayer);

  //     const maxRainfall = Math.max(...rainfallPoints.map(p => p[2]));
  //     console.log('maxRainfall', maxRainfall);

  //     const newIdwLayer = L.idwLayer(allPoints, {
  //       opacity: 0.7,
  //       cellSize: 15,
  //       exp: 6,
  //       max: maxRainfall,
  //       clipBounds: map.getBounds(),
  //       gradient: {
  //         0: '#000066',
  //         0.3: 'cyan',
  //         0.6: 'yellow',
  //         1: '#ff0000'
  //       }
  //     });

  //     newIdwLayer.addTo(map);
  //     setIdwLayer(newIdwLayer);
  //     console.log('newIdwLayer', newIdwLayer);

  //     if (layerControls) {
  //       layerControls.addOverlay(newIdwLayer, 'Rainfall IDW');
  //     }
  //   };


  // const performIdw = () => {
  //     if (!selLayer1 || !selLayer2) {
  //         console.error("Please select both layers");
  //         return;
  //     }

  //     const layerData1 = Canvas.getLayerData(selLayer1); // Point layer
  //     const layerData2 = Canvas.getLayerData(selLayer2); // AOI polygon
  //     const aoiFeature = layerData2.features[0];
  //     const aoiGeom = aoiFeature.geometry;

  //     if (!layerData1 || !aoiFeature || !aoiGeom) {
  //         console.error("Invalid input layers");
  //         return;
  //     }

  //     // 1. Convert AOI to turf polygon
  //     const turfAOIPolygon = polygon(aoiGeom.coordinates);

  //     // 2. Filter rainfall points that fall inside AOI polygon
  //     const rainfallPoints = layerData1.features
  //         .map(f => {
  //             const coords = f.geometry.coordinates;
  //             const rainVal = f.properties.rainfall_m || 1;
  //             return { coords, rainVal };
  //         })
  //         .filter(({ coords }) => {
  //             const pt = point(coords);
  //             return booleanPointInPolygon(pt, turfAOIPolygon);
  //         })
  //         .map(({ coords, rainVal }) => [coords[1], coords[0], rainVal]); // [lat, lng, value]

  //     if (rainfallPoints.length === 0) {
  //         console.error("No points inside AOI");
  //         return;
  //     }

  //     // 3. Calculate dynamic max
  //     const maxRainfall = Math.max(...rainfallPoints.map(p => p[2]));

  //     // 4. Remove previous IDW layer
  //     if (idwLayer && map) map.removeLayer(idwLayer);

  //     // 5. Create new IDW layer with only AOI-bound points
  //     const newIdwLayer = L.idwLayer(rainfallPoints, {
  //         opacity: 0.7,
  //         cellSize: 15,
  //         exp: 6,
  //         max: maxRainfall,
  //         gradient: {
  //             0: '#000066',
  //             0.3: 'cyan',
  //             0.6: 'yellow',
  //             1: '#ff0000'
  //         }
  //     });

  //     newIdwLayer.addTo(map);
  //     setIdwLayer(newIdwLayer);
  //     if (layerControls) {
  //         layerControls.addOverlay(newIdwLayer, 'Rainfall IDW');
  //     }
  // };

  const performIdw = () => {
    if (!selLayer1) {
      console.error("Please select a layer");
      return;
    }

    const layerData = Canvas.getLayerData(selLayer1);
    if (!layerData || !layerData.features?.length) {
      console.error("Invalid layer data");
      return;
    }

    // Extract rainfall points: [lat, lng, value]
    const rainfallPoints = layerData.features
      .filter(f => f.geometry?.type === "Point")
      .map(f => [
        f.geometry.coordinates[1], // lat
        f.geometry.coordinates[0], // lng
        selProp ? f.properties[selProp] : (f.properties.value ?? 1)
        // f.properties.rainfall_m ?? f.properties.value ?? 1 
      ]);

    if (rainfallPoints.length === 0) {
      console.error("No point features found in selected layer");
      return;
    }

    // Compute bounds from selLayer1's features using Turf
    const bbox = turf.bbox(layerData); // [minX, minY, maxX, maxY]
    const southWest = L.latLng(bbox[1], bbox[0]);
    const northEast = L.latLng(bbox[3], bbox[2]);
    const clipBounds = L.latLngBounds(southWest, northEast);

    // Remove existing IDW layer
    if (idwLayer && map) map.removeLayer(idwLayer);

    // Determine max value
    const maxVal = Math.max(...rainfallPoints.map(p => p[2]));

    // Create new IDW layer
    const newIdwLayer = L.idwLayer(rainfallPoints, {
      opacity: 0.8,
      cellSize: 15,
      // exp: 2,
      exp: expValue,
      max: maxVal,
      clipBounds,
      gradient: {
        0: '#000066',
        0.3: 'cyan',
        0.6: 'yellow',
        1: '#ff0000'
      }
    });

    newIdwLayer.addTo(map);
    setIdwLayer(newIdwLayer);
    if (layerControls) {
      layerControls.addOverlay(newIdwLayer, `IDW of ${selProp}`);
    }

    console.log('IDW generated using selLayer1 bounds only');
  };


 return (
  <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">

    {/* ── Trigger Button ── */}
    <button
      className="btn text-white"
      title="IDW Interpolation"
      onClick={() => setshow(!show)}
      style={{ backgroundColor: "black", width: "40px", height: "40px", borderRadius: "50%", border: "none" }}
    >
      <i className="fa-solid fa-network-wired" />
    </button>

    {show && (
      <div ref={toolRef} className="toolsvis" style={{ display: "flex", flexDirection: "column", width: "240px", padding: "10px 12px" }}>

        {/* ── Header ── */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          paddingBottom: "8px", marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.12)"
        }}>
          <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
            <i className="fa-solid fa-network-wired" style={{ marginRight: "6px", fontSize: "11px" }} />
            IDW Interpolation
          </span>
          <span
            onClick={() => setshow(false)}
            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        {/* ── Content ── */}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>

          {/* Vector Layer Select */}
          <select
            onChange={(e) => setSelLayer1(e.target.value)}
            value={selLayer1}
            className="form-select text-white swipe-options"
            style={{ backgroundColor: "transparent", fontSize: "12px", border: "1px solid rgba(255,255,255,0.25)", color: "white", borderRadius: "4px" }}
          >
            <option value="">Select Vector Layer</option>
            {vectors.map((comp) => (
              <option key={comp} value={comp}>{comp}</option>
            ))}
          </select>

          {/* Property Select */}
          {selLayer1 && props && (
            <select
              onChange={(e) => setSelProp(e.target.value)}
              value={selProp}
              className="form-select text-white swipe-options"
              style={{ backgroundColor: "transparent", fontSize: "12px", border: "1px solid rgba(255,255,255,0.25)", color: "white", borderRadius: "4px" }}
            >
              <option value="">Select Property</option>
              {props
                .filter((col) => !["selection", "_parentLayer", "_layerColor"].includes(col))
                .map((comp) => (
                  <option key={comp} value={comp}>{comp}</option>
                ))}
            </select>
          )}

          {/* Exponent Input */}
          <div>
            <label style={{ fontSize: "11px", color: "#aaa", marginBottom: "3px", display: "block" }}>
              Exponent (exp)
            </label>
            <input
              type="number"
              className="form-control text-white"
              value={expValue}
              onChange={(e) => setExpValue(Number(e.target.value))}
              min={1}
              step={1}
              style={{
                backgroundColor: "transparent", fontSize: "12px",
                border: "1px solid rgba(255,255,255,0.25)",
                color: "white", borderRadius: "4px", padding: "5px 8px",
              }}
            />
          </div>

          {/* Generate Button */}
          <button
            className="btn btn-primary border-0"
            style={{ width: "100%", height: "30px", fontSize: "12px" }}
            onClick={performIdw}
            disabled={!selLayer1}
            title={!selLayer1 ? "Please select a layer" : "Generate IDW"}
          >
            Generate IDW
          </button>

        </div>
      </div>
    )}
  </div>
);
}